// extracted by mini-css-extract-plugin
export default {"page":"zX-z","cartModal":"AX-z","checkout":"BX-z","placeholder":"CX-z","account":"DX-z"};